import { useContext } from 'react'
import styled from 'styled-components'
import { CreationSourceEditorContext } from '../../manager'
import Input from './input'

const Inputs = styled.div`
    grid-column: span 8;
`

const CreationSourceEditorCaptionInputs = () => {
    const { captions, setCaptions } = useContext(CreationSourceEditorContext)

    const removeCaptionByIndex = (index: number) => {
        const newCaptions = [...captions]
        newCaptions.splice(index, 1)
        setCaptions(newCaptions)
    }

    return (
        <Inputs>
            {captions.map((caption, i) => (
                <Input
                    key={`source-editor-caption-input-${i}`}
                    {...{
                        caption,
                        index: i,
                        onRemove: () => removeCaptionByIndex(i),
                    }}
                />
            ))}
        </Inputs>
    )
}

export default CreationSourceEditorCaptionInputs
